import React, { useEffect, useRef, useState } from 'react'
import partsService from "../../../../services/partsservice";
import helperfunctions from '../../../../utils/helperfunctions';
import { containerIprops } from './billinginfointerface';
import { useCartContext } from '../../../ShoppingCart/shoppingcart';
import { ICartContextType } from '../../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface';
import BillingInfo from './billinginfo';
import { useSelector } from 'react-redux';
import { selectors as globalDataSelector } from "../../../../state/features/common/globaldata";
import { selectors as headerSelector } from "../../../../state/features/header";

const BillingInfoContainer = (props: containerIprops) => {

  const { stepperDetails }: ICartContextType = useCartContext();
  const initialDataList = { loading: false, data: [] };
  const initialLoadingDataList = { loading: true, data: [] };
  const [savedAddressList, setSavedAddressList] = useState<any>(initialDataList);
  const [stateList, setStateList] = useState(initialDataList);
  const [countryList, setCountryList] = useState(initialDataList);
  const [savedAddressOptions, setSavedAddressOptions] = useState([]);
  const infoErrorObj = {
    addressId: false, firstName: false, lastName: false,
    address1: false, address2: false, city: false, countryName: false, stateName: false, postalCode: false
  }
  const { globalData, headercurrentuser }: any = useSelector(
    state => ({
      headercurrentuser: headerSelector.currentuser(state),
      globalData: globalDataSelector.globaldata(state)
    })
  );

  const billingRefs:any = props?.baseRef;

  const scrollToErrorFieldBilling = () => {
      const errorFieldsBilling = [
          'savedAddress',
          'firstName',
          'lastName',
          'address1',
          'city',
          'countryName',
          'stateName',
          'postalCode',
      ];

      const firstErrorField = errorFieldsBilling.find((field) => stepperDetails?.payment?.error?.[field]);

      if (firstErrorField && billingRefs[firstErrorField].current) {
          billingRefs[firstErrorField].current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
  };

  useEffect(() => {
      const errorObj = stepperDetails?.payment?.error;
      if (errorObj && Object.keys(errorObj) && props?.isNextClick) {
        scrollToErrorFieldBilling();
      }
  }, [ props?.isNextClick ]);

  useEffect(() => {
    if (savedAddressOptions?.length) {
      if (stepperDetails?.payment?.addressId == null) {
        const selectedObj: any = savedAddressList?.data?.find((item: any) => item?.isDefault === true) ?? {};
        const addressId = selectedObj?.addressId ?? 0;
        props?.updatePaymentDetails({ ...stepperDetails?.payment, ...selectedObj, "savedAddress": addressId, "addressId": addressId });
      } else if (stepperDetails?.payment?.addressId) {
        const selectedObj: any = savedAddressList?.data?.find((item: any) => item?.addressId == stepperDetails?.payment?.addressId) ?? {};
        const addressId = selectedObj?.addressId ?? 0;
        props?.updatePaymentDetails({ ...stepperDetails?.payment, "savedAddress": addressId, "addressId": addressId });
      }
    }
  }, [savedAddressOptions, stepperDetails?.payment]);

  const getSavedAddressList = async () => {
    try {
      setSavedAddressList(initialLoadingDataList);
      const reqBody = {
        orderId: 0,
        userAadId: headercurrentuser?.azureADId,
        customerId: globalData?.CustomerId ?? '',
        addressType: 1,
        isGuest: headercurrentuser?.isGuestUser
      }
      const response = await partsService.getSavedAddressList(reqBody);
      if (response?.isSuccess) {
        const addressList = response?.data?.addresses ?? [];
        setSavedAddressList({ loading: false, data: addressList });
        const displayNameList = addressList?.map((item: any) => {
          return {
            value: item?.addressId,
            title: item?.displayName
          };
        }) ?? [];
        setSavedAddressOptions(displayNameList);
        if (!addressList?.length) {
          props?.updatePaymentDetails({
            ...stepperDetails?.payment, savedAddress: '', addressId: 0,
            companyName: '', firstName: '', lastName: '', address1: '', address2: '', city: '',
            countryName: '', stateName: '', postalCode: '', countryCode: '', stateCode: ''
          });
        }
      } else {
        setSavedAddressList(initialDataList);
        helperfunctions.showErrorMessage(`${response?.msg}`);
      }
    } catch (error) {
      setSavedAddressList(initialDataList);
      helperfunctions.showErrorMessage(`${error}`);
    }
  }

  const getCountryLists = async () => {
    try {
      setCountryList(initialLoadingDataList);
      const countryResponse = await partsService.getCountryList();
      if (countryResponse?.isSuccess) {
        setCountryList({ loading: false, data: countryResponse?.data ?? [] });
      } else {
        setCountryList(initialDataList);
        helperfunctions.showErrorMessage(`${countryResponse?.msg}`);
      }
    } catch (countryError) {
      setCountryList(initialDataList);
      helperfunctions.showErrorMessage(`${countryError}`);
    }
  }

  const getStateLists = async (countryCode: any) => {
    if (countryCode) {
      try {
        setStateList(initialLoadingDataList);
        const stateResponse = await partsService.getStateList(countryCode);
        if (stateResponse?.isSuccess) {
          setStateList({ loading: false, data: stateResponse?.data ?? [] });
        } else {
          setStateList(initialDataList);
        }
      } catch (stateError) {
        setStateList(initialDataList);
        helperfunctions.showErrorMessage(`${stateError}`);
      }
    } else {
      setStateList(initialDataList);
    }
  }

  useEffect(() => {
    getSavedAddressList();
    getCountryLists();
    if (stepperDetails?.payment?.countryCode) {
      getStateLists(stepperDetails?.payment?.countryCode)
    }
  }, []);


  const onBillingInfoChange = (value: any, name: string) => {
    const errorObj = { ...stepperDetails?.payment?.error };
    errorObj[name] = false;
    const err = { ...errorObj };
    if (name?.toLowerCase() === 'savedaddress') {
      updateSavedAddress(name, value, err)
    } else {
      let val = stepperDetails?.payment?.postalCode ?? '';
      if (name === 'postalCode') {
        const regex = /[^A-Za-z0-9]/;
        if (value && value?.trim()?.length) {
          if (!regex.test(value) && value?.length <= 9) {
            val = value
          }
        } else {
          val = ''
        }
      } else {
        val = value
      }
      countryStateChanges(name, val, err);
    }
  }

  const updateSavedAddress = (name: any, value: any, err: any) => {
    const selectedObj: any = savedAddressList?.data?.find((item: any) => item?.addressId === value) ?? {};
    if (value === 0) {
      props?.updatePaymentDetails({
        ...props?.paymentDetails, [name]: value, companyName: '', firstName: '', lastName: '', addressId: 0, countryCode: '', stateCode: '',
        address1: '', address2: '', city: '', countryName: '', stateName: '', postalCode: '', error: { ...err, ...infoErrorObj }
      });
      setStateList(initialDataList)
    }
    else {
      getStateLists(selectedObj?.countryCode);
      props?.updatePaymentDetails({ ...props?.paymentDetails, ...selectedObj, savedAddress: selectedObj?.addressId ?? 0, "addressId": selectedObj?.addressId ?? 0, [name]: value, error: { ...err, ...infoErrorObj } });
    }
  }

  const countryStateChanges = (name: any, value: any, err: any) => {
    let shipmentObj = { ...props?.paymentDetails, [name]: value, error: err }
    if (name === 'countryName') {
      const countryCode: any = countryList?.data.find((country: any) => country?.name === value);
      shipmentObj = { ...shipmentObj, countryCode: countryCode?.id ?? "", stateName: '', stateCode: '' }
      if (value) {
        getStateLists(countryCode?.id);
      } else {
        setStateList(initialDataList);
      }
    }
    if (name === 'stateName') {
      const stateCode: any = stateList?.data.find((state: any) => state?.name === value);
      shipmentObj = { ...shipmentObj, stateCode: stateCode?.id ?? "", stateName: value ?? "" }
    }
    props?.updatePaymentDetails(shipmentObj);
  }

  const onHandleChange = (checked: any) => {
    const errorObj = { ...stepperDetails?.payment?.error };
    const err = { ...errorObj, ...infoErrorObj };
    if (checked) {
      const shipment = stepperDetails?.shipment;
      const selectedObj: any = savedAddressList?.data?.find((item: any) => item?.addressId === shipment?.addressId) ?? {};
      const addressId = selectedObj?.addressId ?? 0;
      props?.updatePaymentDetails({ ...props?.paymentDetails, ...shipment, savedAddress: addressId, "addressId": addressId, "sameAsShipping": checked, error: err });
    } else {
      props?.updatePaymentDetails({
        ...props?.paymentDetails, companyName: '', firstName: '', lastName: '', addressId: 0,
        address1: '', address2: '', city: '', countryName: '', stateName: '', postalCode: '', "sameAsShipping": checked, error: { ...err }
      });
    }
  }

  return (
    <BillingInfo
      sameAsShipping={props.sameAsShipping}
      onHandleChange={onHandleChange}
      onBillingInfoChange={onBillingInfoChange}
      paymentDetails={stepperDetails?.payment}
      savedAddressList={savedAddressList}
      stateList={stateList}
      countryList={countryList}
      savedAddressOptions={savedAddressOptions}
      stepperDetails={stepperDetails}
      refs={billingRefs}
    />
  )
}

export default BillingInfoContainer